/* eslint-disable no-shadow */
export enum WalletConnectChainID {
	Mainnet = 'solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp',
	Devnet = 'solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1',
	Deprecated_Mainnet = 'solana:4sGjMW1sUnHzSxGspuhpqLDx6wiyjNtZ',
	Deprecated_Devnet = 'solana:8E9rvCKLFQia2Y35HXjjpWzj8weVo44K',
}

export enum WalletConnectRPCMethods {
	signTransaction = 'solana_signTransaction',
	signMessage = 'solana_signMessage',
	signAndSendTransaction = 'solana_signAndSendTransaction',
	signAndSendAllTransactions = 'solana_signAndSendAllTransactions',
	signAllTransactions = 'solana_signAllTransactions',
}

export const DEFAULT_LOGGER = 'error' as const;

export const WALLETCONNET_PROJECT_ID = '9a6e0405ad86bf5d4479f127ed0c582e' as const;

export const W3M_API_URL = 'https://api.web3modal.org';
